<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="16">
          <a-col :span="6" v-if="userType == '00'">
            <a-form-item label="企业名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-select
                showSearch

                optionFilterProp="children"
                v-model="queryParam.relationId"
                :allowClear="true"
              >
                <a-select-option v-for="type in enterpriseMap" :title="type.enterpriseName" :key="type.enterpriseId">{{type.enterpriseName}}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="角色名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input  v-model="queryParam.roleName"/>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-select  v-model="queryParam.status" default-value="0" :allowClear="true">
                <!--<a-select-option :value="''">全部</a-select-option>-->
                <a-select-option :value="0" title="正常">正常</a-select-option>
                <a-select-option :value="1" title="禁用">禁用</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6" style="text-align: right">
            <a-button type="primary" htmlType="submit" @click="$refs.table.refresh(true)">查询</a-button>
            <a-button style="margin-left: 8px" @click="() => queryParam = {}">清空</a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-divider/>
    <a-row>
      <a-col :span="3">
        <a-dropdown v-if="selectedRowKeys.length > 0">
          <a-button type="danger" icon="delete" @click="delByIds(selectedRowKeys)">删除</a-button>
        </a-dropdown>
      </a-col>
      <a-col :span="5" :offset="16" style="text-align: right">
        <a-button type="primary" icon="plus" @click="$refs.modal.add()">新增</a-button>
      </a-col>
    </a-row>
    <s-table
      style="margin-top: 20px"
      size="default"
      ref="table"
      rowKey="roleId"
      :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
      :columns="columns"
      :data="loadData"

      bordered
    >
      <span slot="status" slot-scope="text,record">
        <a-switch :checked="record.status==0" @change="onChangeStatus(record)"/>
      </span>
      <span slot="action" slot-scope="text, record"  >
        <a @click="handleEdit(record)">编辑</a>
        <a-divider type="vertical" />
        <a v-if="record.canDelete != 1" @click="delByIds([record.roleId])">删除</a>
      </span>
    </s-table>
    <ent-role-modal ref="modal" @ok="handleOk" />
  </a-card>
</template>

<script>
import { STable } from '@/components'
import { getEntRoleList, delRole, changRoleStatus } from '@/api/system'
import EntRoleModal from './modules/EntRoleModal'
import store from '@/store'
import pick from 'lodash.pick'
import { getselectCombox } from '../../api/order/NewlyaddedOrderList'
// import { checkPermission } from '@/utils/permissions'

export default {
  name: 'TableList',
  components: {
    STable,
    EntRoleModal
  },
  data () {
    return {
      visible: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      form: this.$form.createForm(this),
      mdl: {},
      permissions: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          title: '操作',
          width:'20px',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        },
        // {
        //   title: '角色编号',
        //   align:'center',
        //   dataIndex: 'roleId'
        // },
        {
          title: '企业名称',
          dataIndex: 'name',
          align:'center'
        },
        {
          title: '角色名称',
          dataIndex: 'roleName',
          align:'center'
        },
        // {
        //   title: '权限字符',
        //   align:'center',
        //   dataIndex: 'roleKey'
        // },
        // {
        //   title: '显示顺序',
        //   align:'center',
        //   dataIndex: 'roleSort'
        // },
        {
          title: '状态',
          dataIndex: 'status',
          align:'center',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '创建时间',
          align:'center',
          dataIndex: 'createTime',
          sorter: true
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        this.userType = store.getters.userType
        this.id = store.getters.enterpriseId
        if (this.id !== undefined && this.id !== '') {
          this.queryParam.relationId = this.id
        }
        return getEntRoleList(Object.assign(parameter, this.queryParam))
      },
      selectedRowKeys: [],
      selectedRows: [],
      enterpriseMap: [],
      userType: ''
      // addEnable: checkPermission('system:role:add'),
      // editEnabel: checkPermission('system:role:edit'),
      // removeEnable: checkPermission('system:role:remove')
    }
  },
  created () {
    // document.body.addEventListener('keyup', e => {
    //   if (e.keyCode == 13) {
    //     this.$refs.table.refresh(true)
    //   }
    // })
    // 企业名称
    getselectCombox().then(res => {
      if (res.code === 0) {
        this.enterpriseMap = res.data
      } else {
        this.$message.error(res.msg)
      }
    })
  },
  methods: {
    onSelectChange (selectedRowKeys) {
      console.log('selectedRowKeys changed: ', selectedRowKeys)
      this.selectedRowKeys = selectedRowKeys
    },
    handleAdd (parentId) {
      this.$refs.modal.add(parentId)
    },
    handleEdit (record) {
      this.$refs.modal.edit(record)
    },
    onChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    handleOk (value) {
      if(value == 1){
        this.$refs.table.refresh(true)
      }else{
        this.$refs.table.refresh()
      }
    },
    delByIds (ids) {
      let that = this
      this.$confirm({
        title: '删除',
        content: '您确定删除本数据吗？',
        okType: 'danger',
        onOk() {
          delRole({ ids: ids.join(',') }).then(res => {
            if (res.code === 0) {
              that.$message.success(`删除成功`)
              that.handleOk()
            } else {
              that.$message.error(res.msg)
            }
            // const difference = new Set(this.selectedRowKeys.filter(x => !new Set(ids).has(x)))
            // this.selectedRowKeys = Array.from(difference)
            that.selectedRowKeys = []
          })
        },
      });

    },
    onChangeStatus (record) {
      record.status = record.status === '0' ? '1' : '0'
      changRoleStatus(pick(record, 'roleId', 'status'))
      // 发送状态到服务器
    }
  },
  watch: {
    /*
      'selectedRows': function (selectedRows) {
        this.needTotalList = this.needTotalList.map(item => {
          return {
            ...item,
            total: selectedRows.reduce( (sum, val) => {
              return sum + val[item.dataIndex]
            }, 0)
          }
        })
      }
      */
  }
}
</script>
<style scoped>
  .ant-divider.ant-divider-horizontal {
    margin:12px 0 !important;
  }
  /deep/ .ant-table th { white-space: nowrap; }
  /deep/ .ant-table td { white-space: nowrap; padding: 4px 16px !important;}
</style>
